// Copyright (c) 2016 Deere & Company

import React, {
    PropTypes,
    PureComponent
} from 'react';
import {FormattedMessage} from 'react-intl';

class WarrantyStatus extends PureComponent {

    getMessageId(hasWarranty) {

        return hasWarranty ?
            'ACTIVE_WARRANTY' :
            'NO_ACTIVE_WARRANTY';

    }

    render() {

        return (
            <span className='warranty-status'>
                <FormattedMessage id={this.getMessageId(this.props.hasWarranty)}/>
            </span>
        );

    }

}

WarrantyStatus.displayName = 'WarrantyStatus';
WarrantyStatus.propTypes = {
    hasWarranty: PropTypes.bool.isRequired
};

export default WarrantyStatus;



// WEBPACK FOOTER //
// ./src/product/search/components/warranty-status.js